import { render, staticRenderFns } from "./m-document-event-log.vue?vue&type=template&id=6c80f941&scoped=true&lang=pug"
import script from "./m-document-event-log.vue?vue&type=script&lang=js"
export * from "./m-document-event-log.vue?vue&type=script&lang=js"
import style0 from "./m-document-event-log.vue?vue&type=style&index=0&id=6c80f941&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80f941",
  null
  
)

export default component.exports